import { useState, useEffect, useRef } from "react";
import styles from "./SelectElement.module.css";
import Icon from "../Icon/Icon";

export type SelectListItemType = {
  id: string;
  element: React.ReactNode;
  name?: string;
};

type SelectElementPropsType = {
  options?: SelectListItemType[] | null;
  setSelected: (obj: SelectListItemType) => void;
  selected: SelectListItemType;
  className?: string;
  dropdownItemClassName?: string;
  dropdownClassName?: string;
};

const SelectElement = ({
  options,
  selected,
  setSelected,
  className,
  dropdownItemClassName,
  dropdownClassName,
}: SelectElementPropsType) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const selectOption = (option: SelectListItemType) => {
    setSelected(option);
    setIsOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Очистка слушателя при размонтировании
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div
      ref={containerRef}
      className={`${styles.selectContainer} ${
        isOpen ? styles.borderRadiusCut : ""
      } ${className}`}
    >
      <div className={`${styles.selected}`} onClick={toggleDropdown}>
        {selected.element}
        <Icon
          name="select-arrow-to-bot"
          size={18}
          className={`${styles.selectArrowIcon} ${
            isOpen ? styles.selectArrowIconRotate : ""
          }`}
        />
      </div>
      {isOpen && (
        <ul className={`${styles.dropdown} ${dropdownClassName}`}>
          {options &&
            options.map((opt) => (
              <li
                className={`${styles.dropdownItem} ${dropdownItemClassName}`}
                key={opt.id}
                onClick={() => selectOption(opt)}
              >
                {opt.element}
              </li>
            ))}
        </ul>
      )}
    </div>
  );
};

export default SelectElement;
